const fieldName = "items";

export const findBy = function(items, key, value) {
  return items.find(items => items[key] === value);
};

export const findById = function(items, value) {
  return findBy(items, "id", parseInt(value));
};

export const has = function(items, key, value) {
  return items.some(item => item[key] == value);
};

export const getBy = function(items, key, value) {
  if (Array.isArray(value)) {
    return items.filter(item => value.includes(item[key]));
  }
  return items.filter(item => item[key] === value);
};

export const getters = {
  findBy: state => (key, value) => {
    return findBy(state[fieldName], key, value);
  },
  findById: state => value => {
    return findById(state[fieldName], value);
  },
  has: state => (key, value) => {
    return has(state[fieldName], key, value);
  },
  getBy: state => (key, value) => {
    return getBy(state[fieldName], key, value);
  },
};

export default getters;
